import Vue from 'vue'
import App from './App.vue'

let vm = new Vue({
  el: '#app',
  render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js